/**
 * CRM-LIST-VIEWS-V1 (V1-P7) -- SortControl: the reusable list sort primitive
 * (registered shared component; token layer only).
 *
 * Renders the ACTIVE server-validated sort key with a deterministic
 * indicator (C-13); options come from the consumer's frozen sort table --
 * never a free-form column expression (C-7: no order expression from user
 * input reaches a query; the server validates the key again regardless).
 */

export interface SortOption {
  readonly key: string;
  readonly label: string;
}

export interface SortControlProps {
  readonly options: readonly SortOption[];
  readonly active: string;
  readonly onChange: (key: string) => void;
}

export default function SortControl({
  options,
  active,
  onChange,
}: SortControlProps): JSX.Element {
  return (
    <label className="ac-sortcontrol" data-testid="ac-sortcontrol">
      Sort:{' '}
      <select
        value={active}
        data-testid="ac-sortcontrol-select"
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o.key} value={o.key}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
